import { call } from 'redux-saga/effects';

import { Notifications } from 'types';

import { webSocketService } from 'services/WebSocketService';

export function* shuffleSaga() {
  yield call(() => webSocketService.sendMessage({ type: Notifications.SHUFFLE_REQUIRED }));
}
